import { Routes } from '@angular/router';
import { PropertyDashboardComponent } from './dashboard/pages';
import { PropertyDetailsComponent } from './property/pages';
import {
  UserMainComponent,
  UserPropertiesComponent,
  ProfileComponent,
  EditProfileComponent,
  ChangePasswordComponent
} from './user/pages';
import {
  SPReportLearnMoreComponent,
} from './reports/pages';
import { InternalLayoutComponent } from './layouts';
import { AuthGuard } from '../shared/auth/services';
import { UrlQueryParamResolver } from './shared/services/url-query-param.resolver';
import { SharedLayoutMainComponent } from './shared/layouts/main';
import { SupportingListsDashboardComponent } from './supporting-lists/pages';
import { MembershipLevelsComponent } from './membership/pages/membership-levels/membership-levels.component';
import { MembershipMembersPlaceholderComponent } from './membership/pages/membership-members-placeholder/membership-members-placeholder.component';
import { MembershipAccessGuard } from './membership/guards/membership-access.guard';
import { ProjectStatusReportOnlyComponent } from './projects/pages/project-status-report-only/project-status-report-only.component';
import { IntelligencePageComponent } from './intelligence/pages';
import { SpAtlasAccessGuard } from 'app/shared/auth/guards/sp-atlas-access.guard';

// These routes need the user to be login
export const internalRoutes: Routes = [
  // Report-only view (no left nav, no top nav) - open so server-side PDF generation can load it via URL
  {
    path: 'report/project/:id',
    component: ProjectStatusReportOnlyComponent,
    title: 'Project Status Report'
  },
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    resolve: { urlParams: UrlQueryParamResolver },
    children: [
      {
        path: 'properties',
        component: SharedLayoutMainComponent,
        children: [
          {
            path: 'dashboard',
            component: PropertyDashboardComponent,
            title: 'Dashboards'
          },
          // {
          //   path: 'financials',
          //   component: PropertyFinancialsComponent,
          //   data: { roles: ['Admin', 'Manager', 'Member', 'PortfolioAdmin'] },
          //   title: 'Property Financials'
          // },
          {
            path: 'details',
            component: PropertyDetailsComponent,
            data: { roles: ['Admin', 'Manager', 'Member', 'PortfolioAdmin'] },
            title: 'Property Details'
          },
          {
            path: 'details/:id',
            component: PropertyDetailsComponent,
            data: { roles: ['Admin', 'Manager', 'Member', 'PortfolioAdmin'] },
            title: 'Property Details'
          },
          {
            path: 'reports-learn-more',
            component: SPReportLearnMoreComponent,
            title: 'Reports Learn More'
          },
        ]
      },
      {
        path: 'user',
        component: UserMainComponent,
        children: [
          { path: 'properties', component: UserPropertiesComponent, title: 'Properties' },
          { path: 'profile', component: ProfileComponent, title: 'View Profile' },
          { path: 'editprofile', component: EditProfileComponent, title: 'Edit Profile' },
          { path: 'changepassword', component: ChangePasswordComponent, title: 'Change Password' }
        ]
      },

      // Lazy-load newer "feature" modules!
      {
        path: 'portfolio-analytics',
        loadChildren: () => import('./portfolio-analytics/portfolio-analytics.module').then(m => m.PortfolioAnalyticsModule)
      },
      {
        path: 'connected-apps',
        loadChildren: () => import('./connected-apps/connected-apps.module').then(m => m.ConnectedAppsModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule)
      },
      {
        path: 'asset-library',
        loadChildren: () => import('./asset-library/asset-library.module').then(m => m.AssetLibraryModule)
      },
      {
        path: 'accounts',
        loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule)
      },
      {
        path: 'reserves',
        loadChildren: () => import('./reserves/reserves.module').then(m => m.ReservesModule)
      },
      {
        path: 'reserves-v2',
        loadChildren: () => import('./reserves-v2').then(m => m.ReservesV2Module)
      },
      {
        path: 'components',
        loadChildren: () => import('./component/component.module').then(m => m.ComponentModule)
      },
      {
        path: 'plans',
        loadChildren: () => import('./plans/plans.module').then(m => m.PlansModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'supporting-lists',
        component: SharedLayoutMainComponent,
        children: [
          { path: '', component: SupportingListsDashboardComponent, title: 'Supporting Lists' },
        ]
      },
      {
        path: 'intelligence',
        component: SharedLayoutMainComponent,
        canActivate: [SpAtlasAccessGuard],
        children: [
          { path: '', component: IntelligencePageComponent, title: 'Intelligence' },
        ]
      },
      {
        path: 'membership',
        component: SharedLayoutMainComponent,
        canActivate: [MembershipAccessGuard],
        children: [
          { path: '', redirectTo: 'levels', pathMatch: 'full' },
          { path: 'levels', component: MembershipLevelsComponent, title: 'Membership Levels' },
          { path: 'members', component: MembershipMembersPlaceholderComponent, title: 'Members' },
        ]
      },

      //This always needs to be last!!
      { path: '**', redirectTo: 'properties/dashboard' }
    ]
  }
];
